import React from 'react';
import PropTypes from 'prop-types';
import queryString from "query-string";
import Modal from '../common/Modal/Modal';
import RenewalSubmissionForm from './RenewalSubmissionForm';
import {trackPageView} from '@forwardfinancing/analytics-frontend-library';

class RenewalSubmissionPage extends React.Component {
  componentDidMount() {
    trackPageView('New Renewals Submission');
  }

  render() {
    const query = queryString.parse(this.props.location.search);
    const dba = decodeURIComponent(query.dba).replace("&amp;", "&");
    const showModal = false;
    return (
      <div className="renewal-submission-page column page">
        <RenewalSubmissionForm dba={dba} uuid={query.uuid} />
        <Modal
          isActive={showModal}
          onClose={() => {}}
          simpleMessageList={[]}
          errorMessageList={["This renewal has already been submitted!"]}
          desiredClassName={"form-message"}
          linkTo={{link: "/portal/portfolio", text: "Back to Portfolio"}}
          withIndicator={true}
          error={true}
          useCloseButton={false}
          useSpinner={false}
        />
      </div>
    );
  }

}

RenewalSubmissionPage.propTypes = {
  location: PropTypes.object
};


export default RenewalSubmissionPage;
